import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import {ObjectTypes} from '../../../../api/consts';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseSSLInspection from '../../AbstractObjects/GatewayPlan/InnerPages/BaseSSLInspection';
import {useTranslation} from "react-i18next";
import {sslInspectionIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.sslInspection;
const pageId = pageSchema.pageId;

function GatewaySSLInspection({
    gatewayObject,
    planObject,
    setGatewayData,
    setAppiDataValue,
}) {
    const { t } = useTranslation();
    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const gatewayName = gatewayObject[GatewayGetSchema.id];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData(pageId, planPage);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);

    return (
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.SLL_INSPECTION')}
            icon={sslInspectionIcon}
        >
            <BaseSSLInspection
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
                baseObjectName={gatewayName}
                objectType={ObjectTypes.GATEWAY}
                setAppiDataValue={setAppiDataValue}
            />
        </LockToPlanContainer>
    );
}

export default GatewaySSLInspection;